import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

interface SeparatorProps {
  className?: string
  kind?: 'strong' | 'subtle'
}

const Separator = ({ className = '', kind = 'subtle' }: SeparatorProps) => (
  <hr
    className={cn('mc-separator', className, {
      [`mc-separator--${kind}`]: kind,
    })}
    aria-hidden
  />
)

Separator.propTypes = {
  className: PropTypes.string,
  kind: PropTypes.oneOf(['subtle', 'strong']),
}

export default Separator
